<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">

        <section id="header">
            <h1 class="h1Header">{{title}}</h1>
        </section>

        <section id="body">
            <form [formGroup]="addCategoryForm" (ngSubmit)="saveChanges(addCategoryForm.value)">
                <mat-card>
                    <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
                        <div fxFlex="50">
                            <mat-form-field appearance="outline">
                                <mat-label>Nombre</mat-label>
                                <input matInput formControlName="name" required>
                                <mat-error *ngIf="addCategoryForm.controls['name'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                                <mat-error *ngIf="addCategoryForm.controls['name'].hasError('cannotContainSpace')">
                                    El nombre no puede ser un espacio en blanco
                                </mat-error>
                                <mat-error *ngIf="addCategoryForm.controls['name'].hasError('pattern')">
                                    Formato incorrecto, debe comenzar debe comenzar con mayúscula y sin espacios, ej: Ensaladas,Postres...
                                </mat-error>
                                <mat-hint>Debe comenzar debe comenzar con mayúscula y sin espacios</mat-hint>
                            </mat-form-field>
                        </div>
                        <div fxFlex="50">
                            <mat-form-field appearance="outline">
                                <mat-label>Estado</mat-label>
                                <mat-select formControlName="status" required>
                                    <mat-option *ngFor="let option of options" [value]="option.value">
                                        {{option.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="addCategoryForm.controls['status'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-around center">
                        <div fxFlex=100>
                            <mat-form-field appearance="outline">
                                <mat-label>Orden</mat-label>
                                <input matInput formControlName="order" required>
                                <mat-error *ngIf="addCategoryForm.controls['order'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                                <mat-error *ngIf="addCategoryForm.controls['order'].hasError('pattern')">
                                    Este campo sólo puede contener números
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card>
                <br>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-flat-button type="submit" [disabled]="!addCategoryForm.valid"
                        class="save-changes">GUARDAR CAMBIOS</button>
                        <button routerLink="/categories-management" mat-raised-button class="cancel-changes">CANCELAR</button>
                </div>
            </form>
        </section>

    </div>
</div>